export default {
  'Edit': '修改',
  'Save': '保存',
  'Cancel': '取消',
  'Ok': '确定',
  'and': '和',
  'Yes': '确定',
  'No': '取消',
  'Or': '或',
  'Confirm': '确认提示',
  'Saved success': '修改成功',
  'Warning': '警告',
  'Cancel success': '取消成功',
  'Account binding failure': '账号绑定失败',
  'UPDF Code verify': 'UPDF 验证码登录',
  'UPDF Login': 'UPDF 登录',
  'UPDF Password login': 'UPDF 密码登录',
  'UPDF Forgot password': 'UPDF 忘记密码',
  'UPDF Reset password': 'UPDF 重置密码',
  'UPDF Set account info': 'UPDF 完善信息',
  'UPDF Callback {loginType}': 'UPDF 登录成功 {loginType}',
  'UPDF Wechat login': 'UPDF 微信登录',
  'Welcome to': '欢迎使用',
  'Wechat': '微信',
  'Click reload': '点击刷新',
  'Log in by scanning QR code on Wechat<br>and following our official account': '请使用微信扫描二维码<br>并关注公众号登录',
  'Email': '邮箱',
  'Phone': '手机号',
  'Unregistered account will be registered after entering the verification code': '未注册手机号或邮箱输入验证码后自动注册',
  'Unregistered email will be registered after entering the verification code': '未注册邮箱输入验证码后自动注册',
  'Or continue with:': '其他登录方式',
  'By clicking continue, you accept our': '点击下一步即表示您已阅读并接受',
  'License Agreement': '服务协议',
  'Privacy Policy': '隐私政策',
  'Enter your phone number or email...': '请输入你的手机号或邮箱',
  'Enter your email address...': '请输入你的邮箱',
  'Please enter a valid phone number or email': '请输入有效的手机号或邮箱',
  'Please enter a valid email address': '请输入有效的邮箱',
  'Please enter your password': '请输入密码',
  'Enter new password': '请输入新密码',
  'The new password must be at least {min} characters.': '新密码最少{min}位',
  'The new password must be within {max} characters.': '新密码最多{max}位',
  'Nickname must be within {max} characters.': '昵称最多{max}位',
  'Enter your password again': '请再次输入新密码',
  'Please enter your password again': '请再次输入新密码',
  'Those passwords didn\'t match. Try again.': '两次密码输入不一致',
  'Reset success,please log in use new password': '密码设置成功，请使用新密码登录',
  'Continue': '下一步',
  'Check mobile': '验证手机号',
  'Check email': '验证邮箱',
  'Please enter the code sent to<br><span>{account}</span>': '请输入发送至 <span>{account}</span> 的 4 位验证码，有效期 10 分钟',
  'If you do not receive the email, please check your spam or junk folder.': '如未收到邮件，请检查垃圾邮件文件夹',
  'Resend': '重新获取验证码',
  'seconds remaining to resend code': '秒后可重新获取验证码',
  'Verify Later': '稍后验证',
  'Log in with password': '使用帐户密码登录',
  'Log in with password-2': '帐户密码登录',
  'Log in with code': '使用验证码登录',
  'OR': '其它登录方式',
  'Back': '返回',
  'Forgot password?': '忘记密码？',
  'Log in': '登录',
  'Set password': '设置密码',
  'Reset your password': '重新设置密码',
  'Add a photo': '设置头像',
  'Your name': '姓名',
  'What should we call you?': '昵称',
  'First name': '名',
  'Last name': '姓',
  'Please enter first name': '请输入名',
  'Please enter last name': '请输入姓',
  'Please enter your nickname': '请输入昵称',
  'Set a password': '密码',
  'Please enter new password': '请输入密码',
  'Set success': '设置成功',
  'Log in success': '登录成功',
  'Click "<span>Open UPDF</span>" in the above dialog box above to log into your account.': '请点击上方弹窗内“<span>打开UPDF</span>”按钮完成登录',
  'Can\'t see the dialog box? Click here.': '若未看到弹窗，点击这里',
  'Account center': '用户中心',
  'Account Center': '用户中心',
  'Account': '帐户管理',
  'Personal info': '个人信息',
  'Photo': '头像',
  'Preferred name': '昵称',
  'Email-2': '邮箱',
  'UID': 'UID',
  'Mobile phone': '手机号',
  'Country': '国家或地区',
  'Linked Accounts Manage': '绑定账号管理',
  'Select country': '请选择国家或地区',
  'Your Plans of UPDF': '你的UPDF会员',
  'Upgrade to UPDF Pro to get full access to all features without limits.': '更多权限请升级为 UPDF Pro 会员。',
  'Subscriptions': '会员权限',
  'You can manage you plan in Apple ID settings': '可在Apple ID的设置中管理会员权限',
  'Free': '免费',
  'Annual': '年度',
  'Monthly': '月度',
  'Quarterly': '季度',
  'Perpetual': '长久有效',
  'Giveaway': '赠品',
  'Cancel subscription': '取消订阅',
  'Current Plan': '当前会员',
  'Renews': '续费时间',
  'Expire on': '到期时间',
  'VIP Duration': 'VIP时长',
  'Month': '个月',
  'Months': '个月',
  'Activate': '激活',
  'Use Across Devices': '可用设备',
  'As you already have a subscription plan, activating the "Giveaway" plan would make both plans run on your account, but it will not increase the original subscription time. Are you sure you want to activate the "Giveaway" plan?': '由于您已有订阅会员，故激活“赠品”会员后您将同时使用两个会员，但不会增加原始订阅会员的时长。 您也可以选择原有订阅会员到期后，再选择激活这 个“赠品”会员，以获得更长期限的会员权益。您确定要激活“赠品”会员吗？',
  'Activate the "Giveaway" plan': '激活“赠品”会员',
  'Password management': '密码管理',
  'You can set password if you don\'t prefer logging in with codes.': '可设置一个登录密码用于登录账号',
  'Change Password': '修改密码',
  'Set Password': '设置登录密码',
  'Are you sure log out your account?': '确定退出登录吗？',
  'Log out of UPDF account': '退出登录',
  'You may not be able to use all features after logging out of your account until you log back in.': '退出登录后，将无法使用所有功能',
  'Log Out': '退出',
  'Confirm input error': '确认信息错误',
  'Permanently delete your personal information and all data, this operation can\'t be recovered. Enter <span style="color: var(--el-color-primary)">{uid}</span> to confirm the operation.': '永久删除您的个人信息和所有数据，此操作无法恢复。请输入 <span style="color: var(--el-color-primary)">{uid}</span> 确认删除',
  'Delete your account': '删除账号',
  'Your personal information and all data will be removed permanently and can\'t be recovered.': '永久删除个人信息和所有数据，此操作无法恢复',
  'Delete': '删除',
  'The avatar must be an image.': '头像必须是图片格式',
  'You will miss the following membership rights when the subscription expired.': '订阅到期后您将不再享有以下会员权益',
  'Expire on {date}': '您的订阅将于{date}到期',
  'Redeem': '序列号兑换',
  'Redeem-2': '兑换',
  'The license will be bound to your account, and extend the expiration date.': '通过序列号兑换的会员权益，将和你的账号绑定，增加你的会员时长。',
  'Please input license.': '请输入序列号',
  'Incorrect license code.': '无效的序列号',
  'Redeem success.': '兑换成功',
  'Use across Windows, macOS, Android, iOS++No watermark++All annotate tools++Edit PDF text, images and links++Convert PDF to Word, Excel, PPT++OCR Text Recognition++Extract, insert, replace, split pages++Free updates and upgrades': 'Windows、macOS、iOS、Android平台通用++无水印存档++所有注释工具++编辑PDF正文、图片和链接++PDF文件转换为Word、Excel、PPT++OCR 文本识别++ 页面提取、插入、替换、拆分++订阅期内免费更新',
  'Keep UPDF Pro': '继续订阅',
  'Continue Cancellation': '取消续订',
  'Renew': '立即续订',
  'Activate Subscription': '恢复订阅',
  'Success! Your UPDF PRO subscription will be renewed on {date}': '恢复成功! 你的UPDF会员 将会在{date}重新订阅',
  'Upgrade to Pro': '升级到专业版',
  'Please enter the new mobile phone number': '请输入新的手机号',
  'Please enter a valid mobile phone number': '请输入有效的手机号码',
  'Please enter a new email address': '请输入新的邮箱',
  'Please enter a valid email address-2': '请输入有效的邮箱',
  'Verification code error': '验证码错误',
  'Set': '设置',
  'Change': '修改',
  'Link': '绑定',
  'Unlink': '解绑',
  'not set': '未设置',
  'not set-2': '未绑定',
  'Phone Number': '手机号',
  'Google': 'Google',
  'Apple ID': 'Apple ID',
  'Set Phone Number': '设置电话号码',
  'Please enter the phone number and verification code.': '请输入电话号码和验证码',
  'Set Email': '设置邮箱',
  'Please enter the email and verification code.': '请输入邮箱和验证码',
  'Please enter the phone number': '请输入电话号码',
  'Please enter your email': '请输入邮箱',
  'Verification code': '验证码',
  'Send code': '发送验证码',
  'Resend-2': '重新发送',
  'please enter the verification code': '请输入验证码',
  'Please use wechat to scan the QR code and follow the official account binding': '请使用微信扫描二维码并关注公众号绑定',
  'To keep your account safe': '为保证您的帐户安全',
  'Please enter the verification code sent to': '请输入发送到的验证码',
  'Linked Accounts': '账号绑定',
  'Binding success': '绑定成功',
  'linked': '已绑定',
  'Unbind successfully': '解绑成功',
  'Unbinding failure': '解绑失败',
  'Are you sure you want to untie them': '您确定要解绑吗?',
  'UCloud Expires On': '云权益到期时间',
  'UPDF Plan': 'UPDF 会员',
  'Full access to all UPDF features and UCloud benefits.': '可使用 UPDF 所有功能和 UPDF Cloud 会员权益',
  'Full access to all UPDF features and comes with 1-year UCloud benefits.': '完全拥有 UPDF 会员权益和一年云权益',
  'Upgrade to UPDF Pro to get all UPDF features and UCloud benefits.': '升级到 UPDF 会员可获得 UPDF 所有功能和 UPDF Cloud 权益。',
  'Full access to all UPDF features.': '完全拥有 UPDF 会员权益',
  'Create a Company': '创建企业',
  'Please fill in the company information': '请填写企业真实信息',
  'Company Name': '请输入企业名称',
  'Industry Type': '请选择行业类型',
  'Number of Employees': '请选择人员规模',
  'Set up enterprise account': '设置企业帐号',
  'Confirm your enterprise account. You will become the administrator with full management rights.': '请确认你的企业登录帐号，该帐号将成为企业管理员，拥有全部管理权限',
  'Email Address': '请输入你的邮箱地址',
  'Email Address or Phone Number': '请输入你的邮箱地址或手机号码',
  'Please enter the password of {companyName}': '请输入{companyName}的帐户密码',
  'Your company is created successfully.': '你的企业已成功创建',
  'Invite members to join the company by email or by copying the link.': '可通过邮件或复制链接，邀请成员加入企业',
  'Invite members': '邀请成员加入企业',
  'Invite Later': '稍后邀请',
  'Send Invitation': '发送邀请',
  'Copy Link': '复制链接',
  'UPDF PRO': 'UPDF会员',
  'Your account now has full access to all features without limits.': '你的帐号可无限制的使用所有UPDF功能',
  'Your account has not been authorized by the administrator': '你的帐号尚未被管理员授权',
  'All': '所有',
  'Authorized': '已授权',
  'Unauthorized': '未授权',
  'Company Logo': '企业Logo',
  'Contact Information': '联系人信息',
  'Administrator': '管理员',
  'Email-1': '联系邮箱',
  'Phone Number-1': '联系手机',
  'Transfer': '转让',
  'Permanently delete your company information and all data, this operation can not be recovered. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm the operation.': '永久删除您的企业信息和所有数据，此操作无法恢复。请输入<span style="color: var(--el-color-primary)">{companyId}</span>（企业ID）确认删除',
  'Assigned': '已分配',
  'Quick Entry': '快捷入口',
  'Last Login Time': '最后登录时间',
  'Operation': '操作',
  'Search': '查询',
  'Link copied': '链接复制成功',
  'Email, separated by enter': '请输入邮箱地址，多个邮箱用Enter键分隔',
  'This email is already on the list': '该邮箱已在列表中',
  'Invalid Invite Code': '邀请码错误',
  'You have joined the company.': '你已加入该企业',
  'The following accounts are bound to the current login method. Please select the account to log in.': '当前登录方式绑定了以下帐号，请选择帐号登录',
  'Enter password': '输入密码',
  'Please enter the password of <span>{username}</span>': '请输入 <span>{username}</span> 的账户密码',
  'This account is already logged in': '该账号已经登录',
  'You have successfully joined {companyName}': '您已成功加入【{companyName}】',
  'Download UPDF now to share membership benefits': '马上下载 UPDF，共享会员权益',
  'Download UPDF': '下载 UPDF',
  'Please Enter..': '请输入..',
  'Full Name': '姓名',
  'Please login first': '请先登录',
  'administrator': '管理员',
  'Dissolve Company': '解散企业',
  'Permanently delete your business information and data. This action is non-recoverable. Enter <span style="color: var(--el-color-primary)">{companyId}</span> to confirm.': '永久删除您的企业信息和所有数据，此操作无法恢复。请输入（<span style="color: var(--el-color-primary)">{companyId}</span>）确认删除',
  'Accommodation and Food Services': '住宿和餐饮业',
  'Administration, Business Support, and Waste Management Services': '水利、环境和公共设施管理业',
  'Agriculture, Forestry, Fishing, and Hunting': '农、林、牧、渔业',
  'Arts, Entertainment, and Recreation': '文化、体育和娱乐业',
  'Construction': '建筑业',
  'Educational Services': '教育',
  'Finance and Insurance': '金融业',
  'Healthcare and Social Assistance': '卫生和社会工作',
  'Information and Communication': '信息传输、软件和信息技术服务业',
  'Manufacturing': '制造业',
  'Mining': '采矿业',
  'Other Services': '其他',
  'Professional, Scientific, and Technical Services': '科学研究和技术服务业',
  'Real Estate, Rental, and Leasing': '租赁和商务服务业',
  'Wholesale and Retail Trade': '批发和零售业',
  'Transportation and Warehousing': '交通运输、仓储和邮政业',
  'Utilities': '公共管理、社会保障和社会组织',
  'Order No.': '订单编号',
  'Amount': '金额',
  'Product': '商品',
  'Payment Time': '支付时间',
  'Payment Status': '支付状态',
  'Your order is being processed. It may take from 2 to 6 working days to process your payment using the payment method of Sofort/Pix/Boleto. You will be informed via email once the process is done.': '您的订单正在处理中。使用Sofort/Pix/Boleto等支付方式处理您的付款可能需要2至6个工作日。一旦处理完成，我们将通过电子邮件通知您。',
  'Unpaid': '未支付',
  'Failure': '失败',
  'Paid': '已支付',
  'Refunded': '已退款',
  'Pending': '支付中',
  'Expire on:': '过期时间：',
  'Card Expired': '卡片已过期',
  'The payment card can only be changed for orders under subscription. For canceled orders, the renewal has been cancelled, and the payment card cannot be changed. If you need to change the payment card, please renew the subscription of this order in "Subscriptions" first.': '仅可更改已订阅订单的支付卡。对于已取消的订单，续订已被取消，无法更改支付卡。如果需要更改支付卡，请先在“订阅”中重新订阅对应plan',
  'Canceled': '已取消',
  'Change Card': '更改卡片',
  'Active': '可用的',
  'Inactive': '不活跃的',
  'Credit cards associated with subscription orders can be managed here. Here you can modify the credit card that will be used for future renewals. To cancel or restore a subscription, please operate in "Subscriptions".': '与订阅订单关联的信用卡可以在此处管理。您可以修改将来续费所使用的信用卡。要取消或恢复订阅plan，请在“订阅”中操作。',
  'Security': '安全',
  'Payment Management': '支付管理',
  'Order Information': '订单信息',
  'Pay Again': '重新购买',
  'Change successfully': '修改成功',
  'Change failed, please try again': '修改失败，请重试',
  'Order information only includes orders purchased through the website. Applepay and Google Play orders will not be displayed.': '订单信息仅包括通过官网购买的订单。Applepay 和 Google Play 订单将不会显示',
  'Membership': '会员',
  '(Educational)': '(教育版)',
  'Issue an invoice': '开具发票',
  'Download invoice': '下载发票',
  'Bill To:': '账单：',
  'Name': '姓名',
  'Address': '地址',
  'ZIP Code': '邮政编码',
  'Submit': '提交',
  'Please check the information carefully. It cannot be modified after submission. Are you sure to submit?': '请仔细核对信息，提交后不可修改。 确认提交？',
  'Are you sure?': '确定操作？',
  'Invoice Information': '发票信息',
  'Must enter 1-20 characters': '必须输入1-20个字符',
  'Must enter 1-100 characters': '必须输入1-100个字符',
  'Must enter 1-500 characters': '必须输入1-500个字符',
  'Must enter 1-200 characters': '必须输入1-200个字符',
  'Must enter 1-50 characters': '必须输入1-50个字符',
  'Device Management': '设备管理',
  'Desktop': '客户端',
  'Last active': '最后活跃',
  'Login out': '退出登录',
  'Mobile': '移动端',
  'After being removed, the device will automatically log out and needs to be logged in again. Do you confirm the operation?': '被移除后，设备会自动登出，需要重新登录。你确认操作吗？',
  'Settings': '设置',
  'Avatar': '头像',
  'Sign Out': '登出',
  'Join Time': '加入企业时间',
  'Remove Member': '移除成员',
  'Deauthorize': '取消授权',
  'Authorize': '授权',
  'Authorization': '授权状态',
  'Company Overview': '企业概况',
  'Redeem-3': '兑换授权',
  'Buy Licenses': '购买授权',
  'Member Management': '成员管理',
  'Deleted Successfully': '删除成功',
  'Deauthorized Successfully': '取消授权成功',
  'Authorized Successfully': '授权成功',
  'Redeemed successfully': '兑换成功',
  'Company Settings': '企业设置',
  'Company Infomation': '企业信息',
  'The invitation has been sent successfully': '邀请已成功发送',
  'Incorrect format of email': '联系邮箱格式不正确',
  'Incorrect format of phone number': '联系电话格式不正确',
  'Dissolved successfully': '解散成功',
  'License View': '授权视图',
  'Member View': '成员视图',
  'Total Licenses': '授权总数',
  'Total Members': '成员总数',
  'Reset': '重置',
  'Number of Members': '企业规模',
  'Company ID': '企业ID',
  'No staff selected': '未选择成员',
  'Please enter the email': '请输入联系邮箱',
  'Add Member': '邀请成员',
  'Please enter the company name': '请输入企业名称',
  'Permanently delete your business information and data. This action is non-recoverable.': '永久删除您的企业信息和所有数据，此操作无法恢复。',
  'Skip': '跳过',
  'You are not an administrator and do not have permission to access this page.': '你不是管理员，没有访问这个页面的权限',
  'Enterprise management': '企业管理',
  'Flexible configuration, tracking, and management of licenses within your company.': '在公司范围内灵活的设置、跟踪和管理UPDF授权',
  'Enterprise management dashboard': '企业管理后台',
  'Authorization failed': '授权失败',
  'Buy Now': '购买',
  'Buy': '购买',
  'Insufficient licenses available! Want to buy more licenses?': '可用授权不足，是否购买更多授权？',
  'Privilege grant failed': '授权失败',
  'Number of Users': 'Number of Users',
  'Member Avatar': '用户头像',
  'Password must be 6-20 characters, and should have numbers, English letters, or symbols.': '密码必须为6-20位字符，支持数字、英文字母或符号',
  'Not set': '未设置',
  'The current account is the administrator of {companyName}, please log in to the enterprise management platform and dissolve the company to complete the deletion.': '当前帐号是{companyName}的企业管理员，请登录企业管理后台并解散企业，即可删除帐号',
  'Permanently and irreversibly delete the member\'s account and all data. Click OK to complete the deletion': '永久删除该成员帐号和所有数据，此操作不可恢复。点击确认删除',
  'Got it': '我知道了',
  'CompanyId Error': '企业Id错误',
  'Select': '请选择',
  'Enterprise management background': '企业管理后台',
  'Authorized employees': '已授权员工',
  'Authorized members': '授权使用数',
  'The current account already has a perpetual plan. If you need to redeem it again, please change to another account.': '当前帐号已是终身会员，如需再次兑换，请更换帐号',
  'Number of redemption licences': '兑换的数量',
  'Invalid redemption code': '兑换码错误',
  'Allocation of Licence Quotas (Number of employees with licences/Total number of licences)': '授权名额分配情况（已分配权益的员工数/权益总名额）',
  'Authorization of Employee Status (Number of employees with licences/Total number of employees)': '企业员工授权情况（已分配权益的员工数/员工总数）',
  'All the selected enterprise users will be permanently deleted. Do you want to continue?': '所选中的企业用户会被永久性删除，要继续吗？',
  'Share Invitation': '分享邀请',
  'Add Manually': '手动添加',
  'Batch Import': '批量导入',
  'Export All Member': '导出所有成员',
  'Export Selected Member': '导出选中的成员',
  'Account: required. 6-60 characters. The account can not be repeated. It supports numbers, English letters and English symbols.': '帐号：必填，6-60个字符，不可重复，支持数字、英文字母和英文符号',
  'Name: required. The length is limited to 60 characters.': '姓名：必填，60个字符以内',
  'Password: optional. 6-20 characters. It supports numbers, English letters and English symbols.': '密码：非必填，6-20个字符，支持数字、英文字母和英文符号',
  'Mobile phone number: optional. Phone number format.': '手机号码：非必填，格式为手机格式',
  'Whether to authorize: optional. Please fill in [Yes], [No]. If not filled, the default is [No].': '是否授权：选填，请填入[是]、[否]，不填则默认为[否]',
  'Uploaded Failed': '上传失败',
  'The content is wrong. Please modify and reupload.': '内容填写错误，请修改后重新上传',
  'Uploaded Succeed!': '上传成功',
  'Employee Table Template.xlsx': '员工表格模板',
  'You can click to download the Employee table template and fill out the table': '请下载模板并填写表格',
  'Copy the following information and notify the user to log in.': '复制以下信息并通知用户登陆',
  'Must be letters, digits or symbols': '必须是字母数字符号',
  'Please contact administrator to reset password': '请联系管理员重置密码',
  'Please enter account/email/phone number': '请输入帐号/邮箱/手机号',
  'Please enter an effective account/email/phone number': '请输入有效的帐号/邮箱/手机号',
  'Please enter account/email': '请输入帐号/邮箱',
  'Please enter an effective account/email': '请输入有效的帐号/邮箱',
  'Drag the template here, or <em>click to upload</em>': '拖拽模板至此，或<em>点击上传</em>',
  'Account_1': '帐号',
  'Inactivated': '未激活',
  'Activated': '已激活',
  'Deleted': '已注销',
  'Register & log in UPDF account You can convert <span>2 files for FREE</span>': '注册登录即可获得<span>2次免费</span>转换权益',
  'Register & log in UPDF account You can convert <span>2 files per day</span>for FREE': '注册登录即可获得<span>每日2次</span>免费转换权益',
  '{{.shareName}} added you to {{.companyName}}': '{{.shareName}}邀请你加入了{{.companyName}}',
  '{{.shareName}} added you to {{.companyName}}. You can share UPDF membership benefits now. The account information is as follows. Remember to save it and log in.': '{{.shareName}}邀请你加入了{{.companyName}}。你可以共享UPDF会员权益。以下是帐号信息，请保存并登录查看。',
  'Password': '密码',
  'Full name': '姓名',
  'Your password has been reset': '你的密码已重置',
  'Your password has been reset by the administrator. The account information is as follows. Remember to save it and log in.': '你的密码已被管理员重置，以下是帐号信息。请保存并登录查看。',
  'Upload the filled out template:': '上传',
  'Please enter account': '请输入帐号',
  'Please enter password': '请输入密码',
  'Must enter 6-20 characters': '必须输入6-20字符',
  'Please enter 1-30 characters': '请输入1-30字符',
  'Must enter 1-30 characters': '必须输入1-30字符',
  'Please enter email': '请输入邮箱',
  'Please enter an effective email': '请输入有效的邮箱',
  'Please enter phone number': '请输入手机号',
  'Copy': '复制',
  'Only one file can be uploaded': '只能上传一个文件',
  'Accounts can not be repeated. Only numbers, letters, and symbols are supported; it is recommended to name accounts with numbers or letters plus a company suffix (for example: abc@updf, 0100@updf) to ensure uniqueness.': '帐号不可重复，支持数字、英文字母和英文符号；建议将员工帐号以数字或字母加企业后缀的方式命名（例：abc@updf，0100@updf），保证唯一性',
  'Reason of failure:': '导入失败原因',
  'Information copied': '信息已复制',
  'Message sent': '信息已发送',
  'The file can not exceed 10MB': '文件大小不能超过10MB',
  'Must enter 6-60 characters': '必须输入6-60字符',
  'The file exceeds the limit of 30,000 lines, please modify and upload again': '文件超过30000行限制，请修改后重新上传',
  'Support format': '支持格式',
  'Send a message to notify the user to log in': '发送通知提示用户登陆',
  'Please enter email/phone number': '请输入邮箱/手机号',
  'Please enter an effective email/phone number': '请输入有效的邮箱/手机号',
  'Added successfully': '添加成功',
  'Member Info': '成员信息',
  'Send': '发送',
  'The company name only supports Chinese characters': '企业名称仅支持汉字',
  'http_error_4023': '该兑换码为企业兑换码，请到企业管理后台兑换',
  'E-mail: optional. Email format.': '邮箱：非必填，格式为邮箱格式，不可重复',
  'Phone number: optional. Phone number format.': '手机号码：非必填，格式为手机格式，不可重复',
  'Enterprise name': '企业名称',
  'Redeem Now': '立即兑换',
  'Auto-redemption': '自动兑换',
  'You have purchased the Enterprise Plan. Do you want to auto-redeem your plan?': '你已购买企业版会员，是否自动兑换？',
  'Later': '稍后',
  'Redemption code': '兑换码',
  'Users': '用户',
  'It is an enterprise license code, please go to Enterprise Management Dashboard to redeem it.': '该兑换码为企业兑换码，请到企业管理后台兑换',
  'Open UPDF': '打开UPDF',
  'Personal Account': '个人帐号',
  'Enterprise Account': '企业帐号',
  'Language Settings': '语言设置',
  'Language': '语言',
  'Click "Open UPDF" to automatically log in to the enterprise account.': '点击「打开UPDF」，可以自动登录企业帐号',
  'Click "Enterprise Management Dashboard", you can enter the Management Dashboard to redeem plan, set enterprise information, invite members to join the enterprise, and conduct enterprise management.': '点击「企业管理后台」，可以进入管理后台兑换权益，设置企业信息，邀请成员加入企业，进行企业管理',
  'Company': '企业',
  'Please enter your purchased UPDF redemption code, the successful redemption will increase the number of authorized licenses for the company.': '请输入你购买的UPDF兑换码，成功兑换后会增加企业授权数量',
  'Click to Accept': '确认加入',
  'Dissolve success': '解散成功',
  'Upload files up to 100 per month': '支持上传文件数：100个文件/月',
  'Up to 1000 pages per file': '每个文件页数 <= 1000',
  'Ask questions up to 1000 times per month': '提问次数：1000次/月',
  'Up to 2GB per file': '单文件大小限制为2GB',
  '10GB of FREE ADDITIONAL STORAGE': '附赠10GB云空间',
  'You have unlocked advanced AI features': '您已解锁高级AI功能',
  'UPDF AI Pro Plan': 'UPDF AI Pro权益',
  'Upgrade': '升级',
  'Upgrade to UPDF AI Pro monthly Plan to unlock more AI features': '升级为 UPDF AI 会员，可解锁更多AI功能',
  'Full access to all UPDF AI features and UPDF Cloud benefits': '已获取全部UPDF AI功能和UPDF云权益',
  'Success! Your UPDF AI PRO subscription will be renewed on {date}': '恢复成功! 你的UPDF AI会员 将会在{date}重新订阅',
  'Keep UPDF AI Pro': '继续订阅',
  'Continue with Apple': '使用苹果登录',
  'Continue with Google': '使用谷歌登录',
  'You can also <span>continue with SSO</span>': '您还可以<span>使用 SSO</span>',
  'Operation successful': '操作成功',
  'Operation failed, please try again': '操作失败，请重试',
  'Super Admin information': '超级管理员信息',
  'Transfer super Admin': '转让超级管理员',
  'Confirm to transfer super Admin?': '确认转让超级管理员？',
  'You will automatically log out of the management backend interface after the transfer': '转让后将自动登出管理后台界面',
  'Organization management': '组织管理',
  'Super Admin can add 5 ordinary Admin; ordinary Admin have all the operation rights of the management backend, except the following functions: transfer super Admin; add and remove ordinary Admins; dissolve the company.': '超级管理员可以添加5名普通管理员；普通管理员拥有管理后台的所有操作权限，除了以下功能：转让超级管理员；添加、移除普通管理员；解散企业',
  'Add Admin': '添加管理员',
  'Admin list': '管理员列表',
  'Please enter the employee\'s account': '请输入员工账号',
  'Confirm to remove Admin?': '确认移除管理员？',
  'After removal, the employee will not be able to enter the management backend': '移除后该员工将不可进入管理后台',
  'Duplicate addition': '重复添加',
  'Super admin cannot be added as a normal admin': '超级管理员不可被添加为普通管理员',
  'The super admin removes you from the admin of {{.companyName}}. You can continue to use the enterprise account, but you no longer have the authority to manage the enterprise. If you have any questions, please communicate with the super admin in time.': '超级管理员将你从 {{.companyName}} 的普通管理员中移除。你可以继续使用企业账号，但不再拥有管理企业的权限。有任何疑问请及时与超级管理员沟通。',
  'The super admin adds you as a admin of {{.companyName}}. You can log in to the enterprise management backend to manage the enterprise. The admin\'s account password is your UPDF enterprise account password.': '超级管理员将你添加为 {{.companyName}} 的普通管理员。你可以登录企业管理后台，管理企业。管理员的账号密码为你的UPDF企业账号密码。',
  '{{.shareName}} transfers the super administrator of {{.companyName}} to you. You can log in to the enterprise management backend to manage the enterprise. The administrator\'s account password is your UPDF enterprise account password.': '{{.shareName}} 将 {{.companyName}} 的超级管理员转让给你。你可以登录企业管理后台，管理企业。管理员的账号密码为你的UPDF企业账号密码。',
  'Enterprise management dashboard:': '企业管理后台:',
  'Notification of transferring enterprise super admin': '转让企业超级管理员通知',
  'Notification of adding enterprise admin': '添加企业管理员通知',
  'Notification of removing enterprise admin': '移除企业管理员通知',
  'Administrators cannot be deleted': '不能删除管理员',
  'A maximum of 5 normal administrators can be added': '最多添加5名普通管理员',
  'UPDF AI Unlimited': 'UPDF AI 无限版',
  'UPDF AI Standard': 'UPDF AI 标准版',
  'UPDF AI Plan': 'UPDF AI 会员',
  'Upload files unlimited per month++Up to 1000 pages per file++Ask questions unlimited times per month++Up to 2GB per file++100GB of FREE ADDITIONAL STORAGE': '每月上传无限量文件++每个文件最多 1000 页++每月无限次提问++每个文件最多 2GB++100GB 免费额外存储空间',
  'Success! Your {aiType} subscription will be renewed on {date}': '成功！ 您的 {aiType} 订阅将于 {date} 续订',
  'Keep UPDF AI Unlimited': '保持 UPDF AI 无限版',
  'Keep UPDF AI Standard': '保持 UPDF AI 标准版',
  'Organizational License View': '组织授权视图',
  'Unlimited': '无限制',
  'Your company membership benefits will expire in {organizeExpiredTime} days and all membership benefits will be unavailable. Please contact UPDF sales promptly to renew your membership.': '您的公司会员权益将在 {organizeExpiredTime} 天后到期，届时所有会员权益将无法使用。请及时联系 UPDF 销售续订您的会员资格。',
  'Your company\'s membership rights have expired and all membership rights are no longer available. Please contact UPDF sales today to renew your membership.': '您公司的会员权益已过期，所有会员权益已不可使用。 请及时联系 UPDF 销售续订您的会员权益。',
  'Function Settings': '功能设置',
  'Enterprise cloud management': '企业云管理',
  'Enterprise AI management': '企业AI管理',
  'Turn off': '关闭',
  'Trun on': '打开',
  'When the function is turned on, employees can use the cloud function; when it is turned off, the cloud function is turned off and employee accounts can only use local files and cannot upload them to the cloud. This feature is enabled by default.': '功能开启时，员工可以使用cloud功能；关闭后，cloud功能关闭，员工账号只能使用本地文件，不可上传至云端。此功能默认开启。',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Are you sure?': '关闭后，员工账号下所有Cloud功能将被关闭，已上传至Cloud的文件将全部不可访问，确认操作？',
  'After closing, all Cloud functions under the employee account will be closed, and all files uploaded to the Cloud will be inaccessible. Since the AI function requires the Cloud to be turned on before it can be used, if you turn off the Cloud, the AI switch will be turned off at the same time. Are you sure?': '关闭后，员工账号下所有Cloud功能将被关闭，已上传至Cloud的文件将全部不可访问；由于AI功能需要开启Cloud才可使用，关闭Cloud将使AI开关同时关闭，确认操作？',
  'Once enabled, all Cloud functions under the employee account will be enabled, and files can be uploaded to Cloud. Are you sure?': '开启后，员工账号下所有Cloud功能将开启，可以将文件上传至Cloud，确认操作？',
  'When the function is turned on, employees can use AI; when it is turned off, the AI function is turned off. This function is a paid function. If you want to use AI, please contact sales': '功能开启时，AI功能入口开放并可试用；关闭后，AI功能入口隐藏。如需使用AI会员请联系销售',
  'After closing, all AI functions under the employee account will be closed, and all generated AI conversation content will be inaccessible. Are you sure?': '关闭后，员工账号下所有AI 功能将被关闭，已产生的AI对话内容将全部不可访问，确认操作？',
  'After it is enabled, all AI functions under the employee account will be enabled. Are you sure?': '开启后，员工账号下所有AI功能将开启，确认操作？',
  'This function is a paid function. If you want to use AI membership, please contact sales.': '此功能为付费功能，如需使用AI会员请联系销售',
  'Using the AI ​​function requires uploading documents to the Cloud. Please turn on the Cloud function first before turning on the AI ​​switch.': '使用AI功能需要将文档上传至Cloud。请先将Cloud功能打开，才可以打开AI开关',
  'I know': '我知道了',
  'Company User': '企业人数',
  'Company UPDF Licenses': '企业版 UPDF 权益',
  'Company AI Licenses': '企业版 UPDF AI 权益',
  'UPDF': 'UPDF',
  'Use Of State': '使用状态',
  'Residue': '剩余',
  'More Operations': '更多操作',
  'Buy UPDF Licenses': '购买 UPDF 权益',
  'Buy AI Licenses': '购买 UPDF AI',
  'UPDF Authorize': 'UPDF授权',
  'AI Authorize': 'AI授权',
  'UPDF AI': 'UPDF AI',
  'UPDF Deauthorize': 'UPDF取消授权',
  'AI Deauthorize': 'AI取消授权',
  'UPDF AI Authorize': 'UPDF AI授权',
  'Approval Management': '审批管理',
  'Order Number': '订单号',
  'ProductUPDF': '产品',
  'Number': '编号',
  'Created at': '创建于',
  'Payment Method': '付款方式',
  'Money': '金额',
  'Subscription': '订阅',
  'No Subscription': '无订阅',
  'UPDF Lifetime': 'UPDF 终身',
  'AI Annual': 'AI 年度',
  'Non payment': '未付款',
  'payment failure': '付款失败',
  'cancel Subscribing': '取消订阅',
  'Subscribing': '订阅中',
  'Orders': '订单',
  'Create a personal account': '创建个人账号',
  'CompanyAccount': '账号',
  'Unauthorized employee': '未授权员工',
  'Authorized employee': '已授权员工',
  'Order': '订单',
  'Amount of AI plans to be redeemed': '兑换的AI会员数量',
  'Amount of UPDF plans to be redeemed': '兑换的UPDF会员数量',
  'Pay time': '支付时间',
  'Quantity': '数量',
  'Payment status': '支付状态',
  'Active Status': '激活状态',
  'Insufficient licenses available！Please contact sales.': '可用授权不足，请联系销售人员',
  'Please contact the administrator to obtain authorization so that you can use advanced features.': '请联系管理员获取授权，进而使用高级功能。',
  'Administrator Information': '管理员信息',
  'Transfer Administrator': '转让管理员',
  'Are you sure to transfer the administrator?': '是否确定转让管理员？',
  'You will be automatically logged out of the Enterprise Management Dashboard after transfering the administrator. The new administrator can directly log in Management Dashboard through his account and password.': '转让后您将自动登出管理后台。新管理员可以通过其的帐号密码直接登录管理后台',
  'Account binding': '账号绑定',
  'Please enter your email address and verification code': '请输入邮箱和验证码',
  'Please input your email': '请输入邮箱',
  'Invalid verification code, please try again': '无效验证码，请重试',
  'Current version': '当前版本',
  'Check for upgrades': '检查更新',
  'The current version is already the latest version': '当前版本已经是最新版本',
  'Upgrade immediately': '立即升级',
  'Send verification code': '发送验证码',
  'Account or password error': '账号或密码错误',
  'Please contact the administrator to reset the password': '请联系管理员重置密码',
  'Please enter the administrator\'s email': '请输入管理员邮箱',
  'Please enter the 4-digit verification code sent to {account}. <br>Valid for 10 minutes.': '请输入发送至<br>{account}的 4 位验证码，有效期 10 分钟',
  'Private Enterprise Account': '私有化企业用户',
  'This software is about to be downloaded to the server, are you sure?': '客户端即将下载至本服务端，是否确认？',
  'The server will be upgraded, are you sure?': '服务端将升级，是否确认？',
  'Confirm Upgrade': '确认升级',
  'Checking...': '查找...',
  'Server Upgrade': '服务端升级',
  'Software Upgrade': '客户端升级',
  'The upgrade needs to be connected to the Internet, and the latest server configuration can be obtained': '升级需要联网，可获取最新服务端配置',
  'Operation failed. Please try again after the server is connected to the Internet': '操作失败，请在服务器联网后重试',
  'Operation failed. Please try again after connecting to the local area network': '操作失败，请连接局域网后重试',
  'No permission. You are about to be automatically logged out': '没有权限，即将自动登出',
  'Insufficient license is available! Contact sales to buy more.': '可用授权不足！ 联系销售人员购买更多。',
  'Your annual plan has {expireTime} days to expire, please contact sales to purchase perpetual plan.': '您的年度会员权益还有{expireTime}天到期，请联系销售购买终身权益。',
  'Password has been reset successfully. Please use the new password to log in.': '密码重置成功，请使用新密码进行登录。',
  'This email is used to reset the administrator password: when the administrator forgets the password, click "forgot password" on the login interface, and a verification code can be sent to this email to reset the password (the verification code needs to be connected to the Internet to receive it). When the administrator is transferred, the email will be changed accordingly, and the new administrator can also bind a new email.': '该邮箱用于重置管理员密码：管理员忘记密码时，在登录界面点击忘记密码，可向该邮箱发送验证码来重置密码（验证码需连接互联网接收）。转移管理员时，该邮箱会随之更改，新管理员也可以绑定新的邮箱。',
  'Your version is already the latest version': '您的版本已经是最新版本。',
  'The upgrade needs to be connected to the Internet, and the latest software configuration can be obtained': '升级需要联网，可获取最新客户端端配置',
  'Change binding': '更改绑定',
  'Privatized Enterprise Account': '私有化企业',
  'Enterprise Management Dashboard': '企业管理后台',
  'When upgrading, all client software will be suspended, please remind employees to save in time': '升级时，所有客户端软件将被暂停，请提醒员工及时保存。',
  'Upgrade failed, please try again': '升级失败，请重试',
  'http_error_4024': '兑换码是个人类型，在企业类型兑换无法使用',
  'http_error_4408': '网络链接超时，需连接互联网',
  'This version includes bug fixes and performance improvements': '这个版本包括修复漏洞和性能提升',
  'UPDF Annual': 'UPDF 年度',
  'Success! Your subscription will be renewed on {data}': '成功了！您的订阅将于 {data} 续订',
  'You will miss the membership rights when the subscription expired.': '订阅到期后，您将失去会员权利。',
  '⏰ <span>Expire on</span> {data}': '⏰ <span>到期日期</span> {data}',
  'Keep Subscribing': '继续订阅',
  'Active Subscription': '激活订阅',
  'UPDF Sign Annually': 'UPDF 数字签名',
  'UPDF Sign Monthly': 'UPDF 数字签名',
  'Sign': '数字签名',
  'UPDF Sign': 'UPDF 数字签名',
  'Your account now has full access to all UPDF Sign features.': '您的帐户现在可以完全访问所有 UPDF 数字签名功能',
  'Full access to all UPDF Sign features and UPDF Cloud benefits.': '完全访问所有 UPDF 数字签名功能和 UPDF 云权益',
  'UPDF Sign Authorize': 'UPDF 签名授权',
  'Buy Sign Licenses': '购买 Sign 许可证',
  'Amount of Sign plans to be redeemed': '要兑换的 Sign 会员数量',
  'Sign Authorize': 'Sign 授权',
  'Sign Deauthorize': 'Sign 取消授权',
  'Keep UPDF Sign': '保留 UPDF Sign',
  'Legally binding digital signature (certified by AATL).++Automatically notify recipients when signature is sent.++Multiple file signing and batch sending.++Save and manage digital signatures for long-term use.++Provides audit trail and certification.': '具有法律约束力的数字签名（经AATL认证）。++签名发送时自动通知收件人。++多文件签名和批量发送。++保存和管理数字签名以供长期使用。++提供审计跟踪和认证。',
  '{number} signature requests per year.': '签名次数 {}次/{}',
  '{number} signature requests per month.': '签名次数 {}次/{}',
  'Legally binding digital signature (certified by AATL).': '合法绑定数字签名（被AATL认证）',
  'Automatically notify recipients when signature is sent.': '发送签名自动通知签名者',
  'Multiple file signing and batch sending.': '多文件签名和批量发送',
  'Save and manage digital signatures for long-term use.': '数字签名支持管理和长久保存',
  'Provides audit trail and certification.': '提供审计追踪和证书',
  '20GB cloud storage.': 'Cloud +20G/月',
  '24*7 customer service support.': '7*24客服支持',
  'Register & log in UPDF account You can convert <span>2 files per day</span> for FREE': '注册并登录 UPDF 账户，您每天可以<span>免费转换 2 个文件</span>',
  'The annual membership signature quota is unlimited and cannot be modified after authorization to employees. Confirm the authorization?': '年度会员签名额度无限，授权员工后不可修改，确认操作？',
  'Authorized employees do not support cancellation. If you need to change, you can contact sales to modify it once.': '已授权员工不支持取消，如需变更可联系销售修改一次',
  'Usage of amount': '额度使用情况',
  'Total signature amount:': '签名总金额：',
  'Expiration date:': '到期日：',
  'Remaining amount:': '剩余额度：',
  'Usage of Amount Detail': '额度使用情况细节',
  'Amount Consumed': '已使用额度',
  'Last Consumption Time': '上次消耗时间',
  'According to the billing process of relevant institutions, we will complete the billing for users every Wednesday': '根据相关机构开票流程，我们统一每周三为用户完成开票',
  'If you need to create a personal account for use, click here': '如需创建个人账号进行使用，可点击此处',
  'Cancelled': '已取消',
  'http_error_403': '无访问权限',
  'http_error_408': '请求超时，请重试',
  'http_error_500': '系统错误或参数错误，请重试',
  'http_error_1401': '验证失败，请检查所填信息',
  'http_error_2001': '帐户已存在',
  'http_error_2002': '验证码错误，请重试',
  'http_error_2003': '验证码发送次数太多，请稍后重试',
  'http_error_2004': 'IP登录次数太多，请稍后重试',
  'http_error_2005': '密码错误超过5次',
  'http_error_2006': '登录已过期，请重新登录',
  'http_error_2007': '帐户登录次数太多',
  'http_error_2008': '会话异常，请重新登录',
  'http_error_2009': '帐户未登录，请先登录',
  'http_error_2012': '该帐号已被绑定，请解绑或删除账号后重试',
  'http_error_2403': '帐户或密码错误',
  'http_error_2404': '帐户不存在',
  'http_error_2411': '邮件发送失败，请重试或检查邮箱地址',
  'http_error_4004': '不支持续费',
  'http_error_4005': '序列号已被使用',
  'http_error_4006': '序列号已被废弃',
  'http_error_4007': '序列号已被下架',
  'http_error_4008': '序列号已被删除',
  'http_error_4009': '序列号已过期',
  'http_error_4015': '所填折扣码不支持该商品',
  'http_error_4016': '折扣码超出使用限额',
  'http_error_4019': '商品不存在',
  'http_error_4020': '折扣码不存在',
  'http_error_4021': '订单不存在',
  'http_error_4022': '会员不存在',
  'http_error_4026': '兑换码已失效',
  'http_error_4027': '折扣码不存在',
  'http_error_4028': '您已经是永久会员，无需兑换。',
  'http_error_4014': '序列号与你的账号不匹配',
  'http_error_4401': '交易模块参数验证错误',
  'http_error_4404': '数据不存在',
  'http_error_4502': '请求超时，请重试',
  'http_error_6004': '不能删除自己',
  'http_error_6001': '自己不能授权自己本身',
  'http_error_6002': '自己不能取消授权自己本身',
  'http_error_6003': '可用授权不足',
  'http_error_6005': '邀请码已过期',
  'http_error_6506': '导出数据为空',
  'http_error_6507': '导入未完成',
  'http_error_6508': '导入文件为空',
  'http_error_6509': '不是有效Excel',
  'http_error_6012': '邮箱已存在',
  'http_error_6013': '手机号已存在',
  'http_error_6006': '当前企业已被禁用',
  'http_error_2204': '你的订阅计划处于激活状态，删除帐户前请取消订阅',
  'UPDF Account Center': 'UPDF 用户中心',
  'Profile': '个人信息',
  'Products and Plans': '商品和订阅',
  'Payment and Order': '付款和订单',
  'Account Settings': '账号设置',
  'Account Types': '账号类型',
  'Save Changes': '保存更改',
  'Newsletter Subscription Preferences': '邮件推送订阅偏好',
  'Subscribe to our newsletter about news, offers and tips.': '订阅我们的邮件推送，了解新闻、优惠和提示。',
  'Redeem License': '兑换码',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product and Plans” first.': '您可以在此处管理订阅订单的信用卡。信用卡由第三方支付机构存储，UPDF 不存储任何信用卡信息。如果您需要解除绑定，请先在“商品和订阅”中取消订阅。',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Pay orders will not be displayed here.': '订单信息仅包括通过网站购买的订单。Apple Pay 和 Google Pay 订单不会显示在此处。',
  'Card Details': '信用卡详情',
  'Device Name': '设备名称',
  'Location': '位置',
  'Manage': '管理',
  'Linked Account': '关联账号',
  'Status': '状态',
  'Actions': '操作',
  'No data': '暂无数据',
  'Log in with WeChat Scan': '使用微信登录',
  'Log in with Account/Email/Phone Number': '使用账号/邮箱/手机号登录',
  'Registration is successful! Please fill in the following information': '注册成功！请填写以下信息',
  'Get Started': '开始',
  'Subscribe to our newsletter, Offers and Tips.': '订阅我们的邮件推送、优惠和提示',
  'Please verify you are human': '请验证您是人类',
  'Let us get to know you better': '让我们更好地了解您',
  'How do you plan to use UPDF?': '您计划如何使用 UPDF？',
  'For personal use': '个人使用',
  'For work': '工作使用',
  'For my study or education work': '学习或教育工作',
  'How did you hear about us?': '您是如何知道我们的？',
  'Search (Google, Bing, etc.)': '搜索 ( 谷歌，必应等)',
  'Internet(newsletter, publication, blog etc.)': '国际网络（电子报、出版品、博客等）',
  'Internet ads': '网络广告',
  'Youtube': 'Youtube',
  'Tiktok': 'TikTok',
  'Social media(Linkedin, Facebook, X, instagram etc.)': '社群媒体（Linkedin、Facebook、X、instagram 等）',
  'From a friend or colleague': '来自同学和朋友的推荐',
  'Others(please specify)': '其他(请说明)',
  'Please specify': '请说明',
  'What features do you plan to use with UPDF?': '您打算使用UPDF的哪些功能?',
  'AI': 'AI',
  'Edit PDF': '编辑 PDF',
  'Annotate PDF': '注释 PDF',
  'Convert PDF': '转换 PDF',
  'OCR': 'OCR',
  'Create, fill and sign PDFs': '创建, 填写和签名PDF文件',
  'Organize PDF pages': '组织 PDF 页面',
  'Redact and protect PDFs': '云同步',
  'I don\'t know yet': '我不知道',
  'What’s your age group?': '您的年龄段是什么?',
  'Under 18': '18岁以下',
  '18-24': '18-22',
  '25-34': '23-26',
  '35-44': '27-30',
  '45-54': '31-40',
  '55-64': '40-50',
  '65 and over': '50岁以上',
  'I prefer not to say': '我不想回答',
  'What kind of work do you do?': '您从事什么工作？',
  'Select your role or job title': '选择您的角色或职位',
  '本科在读': '本科在读',
  '硕士在读': '硕士在读',
  '博士在读': '博士在读',
  '教师': '教师',
  'Education (students or education Staff)': '教育（学生或教育人员）',
  'Healthcare': '医疗健康',
  'IT': 'IT',
  'Finance': '金融',
  'Legal': '法律行业',
  'Creative industries': '创意产业',
  'Engineering': '工程行业',
  'Goverment and public service': '政府和公共服务',
  'Non-profit and NGOs': '非营利组织和非政府组织',
  'Media and entertainment': '媒体和娱乐',
  'Marketing and advertising': '营销和广告',
  'Energy and utilities': '能源和公用事业',
  'Manufacturing_1': '制造业',
  'Real estate': '房地产',
  'Human resource': '人力资源',
  'Telecommunication': '电信',
  'Consulting': '咨询',
  'Building and construction': '建筑及施工',
  'Retired': '已退休',
  'Others': '其他',
  'Tell us a bit more': '告诉我们更多信息',
  'Next': '下一步',
  'Skip All': '跳过所有',
  'Finish': '完成',
  'Registration is successful!': '注册成功！',
  'Change Payment Method': '更换支付方式',
  'http_error_1400': '人机验证失败',
  'http_error_2400': '邮箱验证失败',
  'http_error_6011': '账号已存在',
  'Feedback': '反馈',
  'Very Dissatisfied': '非常不满意',
  'Dissatisfied': '不满意',
  'Neutral': '一般',
  'Satisfied': '满意',
  'Very Satisfied': '非常满意',
  'Attachment': '附件',
  'Is there anything we can help you with?': '您有什么问题需要我们帮助吗？',
  'Your email': '您的邮箱',
  'Hello, we have received your feedback and will respond to you as soon as possible. Please be patient, and thank you for your understanding.': '您好，我们已收到您的反馈，并将尽快给您回复。请耐心等待，感谢您的理解。',
  'Submission Failed': '提交失败',
  'Please correctly fill in your email address.': '请正确填写您的邮箱地址。',
  'Invalid email address, please re-enter.': '邮箱地址无效，请重新输入。',
  'Please provide detailed feedback content.': '请详细填写您要反馈的内容。',
  'Unbind Card': '解绑卡',
  'Are you sure you want to unlink this credit card?': '确定解绑该信用卡吗？',
  'Unbind': '解绑',
  'Use email verification': '使用邮箱验证',
  'Use phone verification': '使用手机号验证',
  'Permanently delete your personal information and all data, this operation can’t be reconvered.': '永久删除您的个人信息和所有数据，此操作无法恢复。',
  'Please select one of the currently linked accounts to receive the verification code to proceed with your account deactivation.': '请选择已绑定的账号之一进行验证',
  'Other verification methods': '其它验证方式',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time and <a href="#" class="change-pass">change the password</a>.': '此处会显示有权限登录该账号的所有设备。 如果您不希望某设备继续登录该账号，可以及时移除该设备并<a href="#" class="change-pass">修改密码</a>。',
  'All devices that have permission to log in to this account will be displayed here. If you do not want a device to continue logging into the account, you can remove the device in time.': '此处会显示有权限登录该账号的所有设备。 如果您不希望某设备继续登录该账号，可以及时移除该设备。',
  '<span>{inviteNickName}</span> invites you to join <span>{companyName}</span> to share UPDF membership benefits.': '<span>{inviteNickName }</span> 邀請你加入 <span>{companyName }</span>，共享 UPDF 會員權益',
  'You’ve been invited': '你已受邀',
  'Free Trial': '免费试用',
  'Accept now to access exclusive UPDF membership benefits.': '立即接受以获取 UPDF 会员专享福利。',
  'Accept Invitation': '接受邀请',
  'Welcome aboard! You’re all set.': '欢迎加入！您已准备就绪。',
  'Download now to share membership benefits.': '下载并登录以解锁 UPDF 的所有功能。',
  'Start Using UPDF': '开始使用 UPDF',
  'Account Details': '帐户详情',
  'After unsubscribing, you will no longer receive our email notifications, news, offers, and tips.': '取消订阅后，您将不再收到我们的新闻、优惠和提示电子邮件。',
  'You can manage the credit card for your subscription order here. Credit cards are stored by third-party payment institutions, and we at UPDF do not store any credit card information. If you need to unbind, please cancel your subscription in “Product & Plans” first.': '您可以在此处管理订阅订单的信用卡。信用卡由第三方支付机构存储，UPDF 不会存储任何信用卡信息。如果您需要取消链接您的卡，请先在“产品和计划”中取消订阅。',
  'Order information only included orders purchased through rhe website. Apple Pay and Google Google Pay orders will not be displayed here.': '订单信息仅列出通过 UPDF 官方网站进行的订单。来自第三方平台（例如 Apple Store 或 Goolge Play Store 或其他优惠网站）的订单将不会显示在此处。',
  'Work': '工作',
  'Age': '年龄',
  'Please enter the code sent to<br><span>{account}</span>.': '请输入发送至<span>{account}</span> 的验证码',
  'The code is valid for 10 minutes.': '验证码10分钟内有效',
  'SSO Log in': 'SSO登录',
  'Upgrade AI Assistant to unlock more AI features': '升级AI助手，解锁更多AI功能',
  'Profile Picture': '头像',
  'Account Deletion Confirmation': '删除账号确认',
  'Email/phone number': '邮箱/手机号',
  'Account/email/phone number': '帐号/邮箱/手机号',
  'Account/email': '帐号/邮箱',
  'Get our desktop/mobile app': '下载 UPDF',
  'Plan Types': '订阅类型',
  'Details': '详情',
  'Redeemable {isProduct} Membership Duration:': '可兑换的 {isProduct} 会员时长：',
  'Tax Code': '税号',
  'http_error_4031': '您已是会员，不需重复购买',
  'Send code_2': '发送验证码',
  'View Plans': '立即购买',
  'Add Credit Card': '添加信用卡',
  'Account Information': '账号信息',
  'There are no orders. Would you like to upgrade your plan? <br>Please visit the pricing page to make a purchase.': '暂无订单。您想升级您的计划吗？<br>请访问定价页面进行购买。',
  'Human-machine verification failed, <span>click to retry</span>': '人机验证失败，<span>点击重试</span>',
  'Subscribed Successfully': '订阅成功',
  'Unsubscribe': '取消订阅',
  'Upgrade to UPDF Sign Plan to unlock more Sign features': '升级到 UPDF Sign 会员以解锁更多Sign功能',
  'Subscribe': '订阅',
  'Please scan the QR code using WeChat': '请使用微信扫描二维码',
  'Enter your redemption code': '输入您的兑换码',
  'Credit Card': '信用卡',
}